

export const getOrdinalSuffix = (number) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = number % 100;

    const suffix =
        suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];

    return `${number}${suffix}`;
}

